/*nazifa-v11*/(function(){if(window.__NAZIFA_BOOT_LOADER_V11__)return;window.__NAZIFA_BOOT_LOADER_V11__=1;function asset(name){var nodes=document.querySelectorAll('script[src*="/assets/"]');for(var i=0;i<nodes.length;i++){var u=nodes[i].src||'';if(u.indexOf('/assets/')>-1){return u.replace(/[^/]+\.js[^/]*$/,name);}}return 'https://cdn.shopify.com/s/files/1/0981/3698/1808/t/18/assets/'+name;}if(!document.querySelector('link[href*="nazifa-atelier.css"],link[href*="nazifa-5173.css"]')){var l=document.createElement('link');l.rel='stylesheet';l.href=asset('nazifa-atelier.css');document.head.appendChild(l);}if(!document.querySelector('script[src*="nazifa-atelier-boot.js"]')){var s=document.createElement('script');s.src=asset('nazifa-atelier-boot.js');s.defer=true;document.head.appendChild(s);}})();
import { buildSectionSelector, normalizeSectionId, sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback, onDocumentReady } from '@theme/utilities';

/**
 * Hydrates a section using the Section Rendering API preserving states.
 * Only updates elements with data-hydration-key attribute. This ensures that non-targeted nodes do not have their markup/state updated unnecessarily.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
async function hydrateSection(sectionId, url) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') {
    return;
  }

  await sectionRenderer.renderSection(normalizedId, { cache: false, url, mode: 'hydration' });

  section.dataset.hydrated = 'true';
}

/**
 * Hydrates a section using the Section Rendering API preserving states, when
 * the DOM is ready.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
export async function hydrate(sectionId, url) {
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}
